import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { VideoFallbackPreviewProps } from "../reducers/types";
import { getFileExtension, formatFileSize, getBrowserSpecificMessage } from "../utils/formatHelpers";

/**
 * Video Fallback Preview Component
 *
 * Displays a fallback UI for video files that can't be played in the current browser.
 * Shows file information, size, format, and a friendly message about compatibility.
 *
 * @param props Component props
 * @returns JSX Element
 */
const VideoFallbackPreview: React.FC<VideoFallbackPreviewProps> = t0 => {
  const $ = _c(26);
  const {
    file,
    errorMessage
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-mb-4 tw-text-iron-400"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="tw-w-16 tw-h-16"><path fillRule="evenodd" d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z" clipRule="evenodd" className="tw-text-iron-500" /><circle cx="19" cy="12" r="2" className="tw-fill-amber-500" /></svg></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== file.name) {
    t2 = <h3 className="tw-text-iron-100 tw-text-lg tw-font-medium tw-mb-2 tw-truncate tw-max-w-xs" title={file.name}>{file.name}</h3>;
    $[1] = file.name;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== file) {
    t3 = getFileExtension(file);
    $[3] = file;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <span className="tw-text-xs tw-font-mono tw-bg-iron-800 tw-px-2 tw-py-1 tw-rounded">{t3}</span>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== file.size) {
    t5 = formatFileSize(file.size);
    $[7] = file.size;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <span className="tw-text-xs tw-bg-iron-800 tw-px-2 tw-py-1 tw-rounded">{t5}</span>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = <div className="tw-flex tw-gap-2 tw-mb-3">{t4}{t6}</div>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== errorMessage || $[15] !== file) {
    t8 = errorMessage ?? getBrowserSpecificMessage(file);
    $[14] = errorMessage;
    $[15] = file;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8) {
    t9 = <p className="tw-mb-2">{t8}</p>;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <p className="tw-text-amber-400 tw-text-xs tw-mt-1">Your file will still be uploaded successfully.</p>;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t9) {
    t11 = <div className="tw-text-center tw-text-iron-400 tw-text-sm tw-px-4 tw-mt-4">{t9}{t10}</div>;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t2 || $[24] !== t7) {
    t12 = <div className="tw-flex tw-items-center tw-justify-center tw-w-full tw-h-full"><div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-full tw-h-full">{t1}{t2}{t7}{t11}</div></div>;
    $[22] = t11;
    $[23] = t2;
    $[24] = t7;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
};
export default VideoFallbackPreview;